export const messages = {
  server: {
    callingServer: "Estableciendo conexión con el servidor...",
    connectingServer: "Conectando con el servidor...",
    successConnectingServer: "Conectado.",
    errorConnectingServer: "Error al conectar con el servidor.",
  }
}